exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3XJC2NOzc8WKWtWtKB6pFL{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);
// Exports
exports.locals = {
	"printPreview": "_3XJC2NOzc8WKWtWtKB6pFL"
};